import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-navy-deep" data-id="element-152" data-mp="1o2vk0ww891a9">
      <div className="max-w-4xl mx-auto" data-id="element-153" data-mp="22368xudz85ss">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-forest-soft border border-forest/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg" data-id="element-154" data-mp="2223kru81ghgk">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold" data-id="element-155" data-mp="14gz4qlll4fgy" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-white text-forest border border-forest/30 mb-8" data-id="element-156" data-mp="1j5luzicr2rmy">
            <ShieldCheckIcon size={48} data-id="element-157" data-mp="1ebr3vtutfadu" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy-deep" data-id="element-158" data-mp="qn7tn8s7gnj4">
            🛡️ Complete 7-Day Money Back Guarantee
          </h2>
          <div className="space-y-6 text-lg text-ink max-w-2xl mx-auto" data-id="element-159" data-mp="lnbylz1hk6fp">
            <p data-id="element-160" data-mp="oz9kqu71izie">
              Open the entire 6-in-1 teaching system. Explore all the bonuses.
              Use the material in your most challenging class this week.
            </p>
            <p className="font-medium text-navy-deep" data-id="element-161" data-mp="yqmfpuo4y5sn">
              If you feel the material is not clear, practical or useful for
              your teaching needs, contact us within 7 days.
            </p>
            <p className="text-forest-deep font-bold text-xl" data-id="element-162" data-mp="628gjblb93fi">
              We will refund 100% of your money. No questions. No forms. No
              hassle.
            </p>
            <p className="text-sm text-warmgray mt-8" data-id="element-163" data-mp="f0aj3vkp044w">
              Because if the material does not deliver the value we promise, we
              don&apos;t want your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}